import { motion } from "framer-motion";
import { Sun, Gauge, Leaf } from "lucide-react";
import { useLang } from "@/i18n";

const solutionIcons = [Sun, Gauge, Leaf];

export default function Solution() {
  const { t } = useLang();

  return (
    <section id="soluzione" aria-labelledby="solution-heading" className="py-20 sm:py-28 scroll-mt-24 border-b border-volt/20 bg-gradient-to-b from-volt/[0.05] to-transparent" data-testid="solution-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-sm font-medium uppercase text-volt" data-testid="solution-overline">
          {t.problem.solutionOverline}
        </motion.p>
        <motion.h2
          id="solution-heading" data-testid="solution-heading"
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
          className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl max-w-3xl text-volt"
        >
          {t.problem.solutionH2}
        </motion.h2>
        <div className="mt-12 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <motion.figure initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="min-w-0">
            <video
              src="/assets/solution-video.mp4" poster="/assets/solution-video-poster.jpg"
              autoPlay muted loop playsInline controls preload="metadata"
              width="1920" height="1088" aria-label={t.problem.videoLabel} aria-describedby="solution-video-caption"
              className="w-full aspect-[30/17] object-contain rounded-lg bg-black"
              data-testid="solution-video"
            />
            <figcaption id="solution-video-caption" className="mt-4 text-xs uppercase text-volt" data-testid="solution-video-caption">{t.problem.imgCaption}</figcaption>
          </motion.figure>
          <div className="space-y-6 min-w-0">
            {t.problem.solutions.map((s, i) => {
              const Icon = solutionIcons[i];
              return (
                <motion.div
                  key={s.title}
                  initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.12 }}
                  className="flex gap-4 border-l-2 border-volt pl-5 py-3" data-testid={`solution-card-${i}`}
                >
                  <Icon aria-hidden="true" className="text-volt shrink-0 mt-1" size={24} strokeWidth={1.5} />
                  <div className="min-w-0">
                    <h3 className="font-display font-semibold text-lg text-volt" data-testid={`solution-title-${i}`}>{s.title}</h3>
                    <p className="mt-2 text-sm text-steel leading-relaxed" data-testid={`solution-description-${i}`}>{s.text}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}